<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>Keycloak設定値登録</h5>
      </div>
      <div class="col-3">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info" v-on:click="back">キャンセルする</button>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <form @submit.prevent="register">
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>項目名称</label>
              </div>
              <div class="col-9">
                <select class="form-control" v-model="keycloak.keycloakKey" required>
                  <option v-for="keycloakKey in keycloakKeyOptions" v-bind:value="keycloakKey.keycloakKey" v-bind:key="keycloakKey.keycloakKey">
                      {{ keycloakKey.keycloakKey }}
                  </option>
                </select>
              </div>
            </div>  
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>設定値</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="200" v-model="keycloak.keycloakValue" class="form-control" autocomplete="off" placeholder="設定値（必須）" required>
              </div>
            </div>  
          </div>
          <button id="register_button" type="submit" class="btn btn-info btn btn-block">登録する</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Create',
  mixins: [sessions,path,headers],
  props: ['realms'],
  data: function(){
    return {
      message: '',
      keycloakKeyOptions: [
        {keycloakKey: 'nichibyo-mobile'},
        {keycloakKey: 'admin-role'}
      ],
      keycloak: {
        hospitalCode: '',
        keycloakKey: '',
        keycloakValue: ''
      }
    }
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    }
  },
  mounted() {
    if(this.$store.getters.hospital.id !== 0){
      this.init()
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.init()
        }
      }
    )
  },
  methods: {
    register() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var code = this.$store.getters.hospital.code
          this.keycloak.hospitalCode = code
          axios.post("/api/keycloak/management/", {
              keycloak: this.keycloak
          },{
            headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('登録されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/keycloak/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/keycloak/index'))
    },
    init() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var code = this.$store.getters.hospital.code
          
          axios.get("/api/keycloak/management/list/" + code,{
            headers: this.headers(accessToken)
          }).then(response => {
            var targets = response.data.data.keycloaks
            var options = this.keycloakKeyOptions.filter((element) => {
                return targets.every((value) => value.keycloakKey != element.keycloakKey)
            })
            if (options.length === 0) this.message = '作成対象が存在しません'
            this.keycloakKeyOptions = options
          }).catch(err => {
            this.message = err.message
          })
          this.keycloakKeyOptions.splice(0)
          if(code === 'master'){
            this.keycloakKeyOptions = 
            this.keycloakKeyOptions.concat([
              {keycloakKey: 'nichibyo-mobile'},
              {keycloakKey: 'admin-role'}
            ])
          } else {
            this.keycloakKeyOptions = 
            this.keycloakKeyOptions.concat([
              {keycloakKey: 'nichibyo-mobile'},
              {keycloakKey: 'realm-management'},
              {keycloakKey: 'manage-users'}
            ])
          }

        } else {
          //this.$router.replace('/login') 
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    getCurrent() {
      //
    }
  } 
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#backBtn {
  float:right;
}
#register_button {
  margin-top: 30px;
}
.radio_label {
  margin-left: 0.5rem;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>